// extracted by mini-css-extract-plugin
export default {"header":"FrameHeader_header__bZoU3","title":"FrameHeader_title__SwuWr","alarms":"FrameHeader_alarms__+yMPD"};